module.exports = __webpack_public_path__ + "media/images/physicianEstate-c16ce8da1166d752ac1218c658c411fe.png";